module.exports = __webpack_public_path__ + "static/media/lesson_complete_ic.cb6786c6.svg";